import axios from 'axios'
import { getAPIUrl } from '../API'

export interface SearchPropertyOwnersListRequest {
  schemeNo: number
  region: string
}

export interface SchemeOwnerResponse {
  sectionNo: number
  flatNo: string
  owner: string
  ownerIDNo: string
  schemeName: string
  address: string
  sectionExtent: string
  type: string
}

export const searchSchemeOwnersList: (
  options: SearchPropertyOwnersListRequest,
) => Promise<SchemeOwnerResponse[]> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/schemeownerslist`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return data.data
}
